import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { authAPI, formatError } from "../utils/api";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9e7e0d6e-4f16-4092-b7c7-18a05794ec67/artifacts/w0k6jgr2_WhatsApp%20Image%202026-04-07%20at%2017.12.34.jpeg";

export default function ForcePasswordReset({ resetToken }) {
  const { setSession } = useAuth();
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword.length < 8) { setError("Password must be at least 8 characters"); return; }
    if (newPassword !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      const res = await authAPI.forcedPasswordReset({
        password_reset_token: resetToken,
        new_password: newPassword,
      });
      // Set session directly from the reset response
      setSession(res.data);
    } catch (e) {
      setError(formatError(e));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F2]">
      <div className="w-full max-w-md px-6">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="Manna Trust" className="h-16 w-16 rounded-full object-cover mb-4 shadow"/>
          <h1 className="text-2xl font-extrabold text-[#3A322C]">Set New Password</h1>
          <p className="text-sm text-[#8A7E73] mt-2 text-center max-w-sm">
            For your security, you must choose a new password before continuing.
            Your new password must be at least 8 characters.
          </p>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-2xl px-5 py-4 mb-6 text-sm text-amber-800">
          <strong>Security notice:</strong> All sessions have been reset. Please set a unique password that you haven't used before.
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-sm p-6 space-y-5">
          <div>
            <label className="text-xs font-bold uppercase text-[#8A7E73] mb-2 block">New Password</label>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="At least 8 characters"
              className="w-full border-2 border-[#E5E1DB] rounded-xl px-4 py-3 outline-none focus:border-[#E8956D] text-base"
              data-testid="new-password-input"
            />
          </div>

          <div>
            <label className="text-xs font-bold uppercase text-[#8A7E73] mb-2 block">Confirm New Password</label>
            <input
              type="password"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="Repeat new password"
              className="w-full border-2 border-[#E5E1DB] rounded-xl px-4 py-3 outline-none focus:border-[#E8956D] text-base"
              data-testid="confirm-password-input"
            />
          </div>

          {error && (
            <div className="bg-[#FBEAE7] text-[#C2624E] rounded-xl px-4 py-3 text-sm font-medium" data-testid="reset-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !newPassword || !confirm}
            className="w-full bg-[#E8956D] text-white rounded-xl py-3.5 font-bold text-base disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="set-password-btn"
          >
            {loading ? "Setting password…" : "Set New Password & Continue"}
          </button>
        </form>
      </div>
    </div>
  );
}
